import { render, staticRenderFns } from "./AdminSnippet.vue?vue&type=template&id=4b85b674&"
import script from "./AdminSnippet.vue?vue&type=script&lang=js&"
export * from "./AdminSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports